import { defineComponent as l, openBlock as r, createBlock as c, unref as a, mergeProps as d, withCtx as p, createElementVNode as e } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const h = /* @__PURE__ */ l({
  name: "IconReassuranceShield6Months",
  __name: "IconReassuranceShield6Months",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (u, n) => (r(), c(a(s), d(t, { "view-box": "0 0 48 48" }), {
      default: p(() => [...n[0] || (n[0] = [
        e("path", { d: "M24.13 23.86c1 0 1.81-.909 1.81-2.03s-.81-2.03-1.81-2.03-1.81.909-1.81 2.03.81 2.03 1.81 2.03" }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M10 24.65V8h28v16.65c0 8.02-8.19 12.9-14 15.35-6.7-2.82-14-7.65-14-15.35m9.81-4.76c0 3.83 1.63 5.7 4.3 5.7a3.78 3.78 0 0 0 4.09-3.78 3.44 3.44 0 0 0-3.51-3.7 3 3 0 0 0-2.64 1.39c.03-2.69.93-3.69 2.1-3.69a1.44 1.44 0 0 1 1.56 1.29h2.26c-.13-1.71-1.42-3-3.78-3-2.67 0-4.38 1.79-4.38 5.79",
          "clip-rule": "evenodd"
        }, null, -1),
        e("path", {
          "fill-rule": "evenodd",
          d: "M46 0H2v24.35C2 36.45 12.81 44.05 24 48c11.15-3.88 22-11.55 22-23.65V0m-4 4v20.35c0 11-11.69 17-18 19.39C8.38 37.8 6 29.09 6 24.35V4h36",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  h as default
};
